// ═══════════════════════════════════════════════════════════════════
//  modules/courriel/constantes.js
//  MAIL_TAGS · DOSSIERS_ORDRE · LIBELLES_DOSSIERS · ICONES_DOSSIERS · URGENCE_COLOR · SENTIMENT_ICON
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

// ═══════════════════════════════════════════════════════════════════════
//  MODULE COURRIEL — v2 · BLOC FRONT (lecture + envoi + analyse IA)
//  À coller dans App.js juste AVANT  `function DashboardHome({ token, user, onNavigate })`.
//  Aucun nouvel import : réutilise THEME, API_BASE, useState, useEffect, useRef.
//
//  ─── LES 4 INSERTIONS À FAIRE AILLEURS DANS App.js ────────────────────
//
//  1) Dans NAV_ITEMS (vers la ligne 2307), après l'entrée "chat" :
//         { id: "courriel", icon: "📧", label: "Courriel", ready: true },
//
//  2) Dans MOBILE_SHORT (vers la ligne 60), ajouter :
//         courriel: "Mail",
//
//  3) Dans `function Dashboard(...)`, dans le bloc `content`, ajouter une ligne :
//         {activeModule === "courriel" && <Courriel token={token} user={user} />}
//
//  4) (optionnel, si le widget du lot 1 n'est pas déjà en place)
//     Dans DashboardHome, dans la rangée des KPI :   <CourrielKpi token={token} />
//     et après le bloc « On y travaille » :          <CourrielPanel token={token} />
//
//  ─── COMPORTEMENT EN CAS DE PANNE ─────────────────────────────────────
//  Le module affiche un message clair si l'IMAP ne répond pas, et les
//  composants du Dashboard (CourrielKpi / CourrielPanel) se masquent
//  silencieusement : le Dashboard ne doit jamais casser à cause du mail.
//
//  ─── CLOISONNEMENT DE L'ANALYSE IA ────────────────────────────────────
//  L'analyse IA des mails s'affiche uniquement ici. Elle n'apparaît pas
//  dans le module Chat en jeu et n'entre dans aucune de ses statistiques.
// ═══════════════════════════════════════════════════════════════════════
export const MAIL_TAGS = {
  a_trier:     { label: "À trier",     color: THEME.amber,     bg: THEME.amberDim },
  partenariat: { label: "Partenariat", color: THEME.gold,      bg: THEME.goldDim },
  support:     { label: "Support",     color: THEME.accent,    bg: THEME.accentDim },
  createur:    { label: "Créateur",    color: THEME.purple,    bg: THEME.purpleDim },
  juridique:   { label: "Juridique",   color: THEME.red,       bg: THEME.redDim },
  spam:        { label: "Indésirable", color: THEME.textMuted, bg: THEME.panel },
  automatique: { label: "Automatique", color: THEME.textDim,   bg: THEME.panel },
  traite:      { label: "Traité",      color: THEME.emerald,   bg: THEME.emeraldDim },
};

// Les quatre dossiers exposés par le backend (ordre d'affichage des onglets)
export const DOSSIERS_ORDRE = ["inbox", "sent", "spam", "trash"];

export const LIBELLES_DOSSIERS = { inbox: "Reçus", sent: "Envoyés", spam: "Indésirables", trash: "Corbeille" };

export const ICONES_DOSSIERS = { inbox: "📥", sent: "📤", spam: "🚫", trash: "🗑" };

export const URGENCE_COLOR = { haute: THEME.red, moyenne: THEME.amber, basse: THEME.textMuted };

export const SENTIMENT_ICON = { positif: "🙂", neutre: "😐", negatif: "🙁" };
